import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageProvider";
import { ArticleActions } from "../articles/ArticlePages";
import { ArticleSummary, useArticlesApi } from "../articles/articlesApi";
import { formatDateTime } from "./dates";
import "../articles/articles.css";

// Admin: every article (drafts, published, removed) with publish / unpublish /
// remove / delete. Articles are uploaded by price-engine/scripts/generate_article.py.
export const ArticlesTab: React.FC = () => {
  const { t, locale } = useLanguage();
  const api = useArticlesApi();
  const [articles, setArticles] = useState<ArticleSummary[] | null>(null);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setError(false);
    api.list(true).then((r) => setArticles(r.articles ?? [])).catch(() => setError(true));
  }, [api]);
  useEffect(load, [load]);

  const replace = (id: string, a: ArticleSummary | null) =>
    setArticles((list) =>
      (list ?? []).flatMap((x) => (x.id !== id ? [x] : a ? [{ ...x, ...a }] : [])),
    );

  return (
    <div className="sp-card">
      <div className="sp-card__head">
        <h3 className="sp-card__title">{t("articles.adminTitle")}</h3>
        <span className="sp-card__sub">{t("articles.adminSub")}</span>
      </div>
      {error ? (
        <div className="sp-empty">{t("articles.loadError")}</div>
      ) : !articles ? (
        <div className="sp-empty"><span className="sp-spinner" /></div>
      ) : articles.length === 0 ? (
        <div className="sp-empty">{t("articles.adminEmpty")}</div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table className="sp-table articles-admin-table">
            <thead>
              <tr>
                <th>{t("articles.colTitle")}</th>
                <th>{t("articles.colStatus")}</th>
                <th>{t("articles.colCreated")}</th>
                <th>{t("articles.colPublished")}</th>
                <th className="num">{t("articles.colWords")}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {articles.map((a) => (
                <tr key={a.id}>
                  <td style={{ minWidth: 260 }}>
                    <Link to={`/artiklar/${a.slug}`}><strong>{a.title}</strong></Link>
                    <div className="article-meta">/{a.slug}</div>
                  </td>
                  <td>
                    <span className={`article-status article-status--${a.status}`}>{t(`articles.status.${a.status}`)}</span>
                  </td>
                  <td>{formatDateTime(a.createdAt, locale)}</td>
                  <td>{a.publishedAt ? formatDateTime(a.publishedAt, locale) : "—"}</td>
                  <td className="num">{a.wordCount ?? "—"}</td>
                  <td>
                    <ArticleActions article={a} compact onChange={(x) => replace(a.id, x)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
